import React, {useEffect, useState, useRef} from "react";
import styles from "../../css/community-my-answers-detailed.module.css";
import editIcon from "../../../../public/images/edit_white.svg";
import deleteIcon from "../../../../public/images/delete_white.svg";
import {Provider, useSelector} from "react-redux";
import newAdminStore from "../../../admin/store/newAdminStore";
import SearchContainer from "../../../admin/containers/SearchContainer";
import copyLinkIcon from "../../../../public/images/copyLinkIcon.svg";
import ActionButtonContainer from "../../../shared/containers/ActionButtonContainer";
import { getDate } from "../../../app/dashboard/utils/get-date";
import { useDispatch } from "react-redux";
import { COMMUNITY_ACTION_TYPES } from "./communityReducer";
import PopUpContainer from "../../../shared/components/PopUpContainer";
import AddEditAnswerPopUp from "./CommunityPopUps/AddEditAnswerPopUp";
import { useCommunityDelete } from "./CommunityCustomHooks/useCommunityDelete";
import ModalDialog from "../../../shared/components/ModalDialog";
import editIconMobile from "../../../../public/images/icons/community-edit-icon.svg";
import deleteIconMobile from "../../../../public/images/icons/community-delete-icon.svg";
import ansIcon from "../../../../public/images/community-ans-icon.svg";
import verifiedMobile from "../../../../public/images/verified-badge.svg";
import {PAGE_HASH_LOCATION} from "../../../app/utils/pages";
import {isMobileOnly} from "react-device-detect";
import {deleteAnswer, fetchDetailedAnswers} from "../../../shared/utils/sash-v2-api";
import backRounded from "../../../../public/images/back_rounded.svg";
import Paginator from "../../../shared/components/Paginator";
import TopNavBar from "../TopNavBar";
import * as JSONWebToken from "jsonwebtoken";
import {getSASHWebToken} from "../../../app/utils/jwt";
import searchBlue from "../../../../public/images/search-blue.svg";


const CommunityMyAnswersDetailed = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [copyStatus, setCopyStatus] = useState({});
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showAnswerPopUp, setShowAnswerPopUp] = useState(false);
  const [threadId, setThreadId] = useState(null);
  const dispatch = useDispatch();
  const [copiedQuestionId, setCopiedQuestionId] = useState(null);
  const myAnswers = useSelector((state) => state.communityReducer.userAnswers);
  const tokenData = JSONWebToken.decode(getSASHWebToken());
  const user =  (tokenData && tokenData.userId) ? tokenData.userId : undefined;
  const [answerId, setAnswerId] = useState(null)
  const {deletePopUp, answerToDelete, handleCommunityDeletePopUp, handleCommunityDeletePopUpClose} = useCommunityDelete();
  const userAnswersCount = useSelector((state) => state.communityReducer.userQuestionAnswersCount)
  const [pageIndex, setPageIndex] = useState(0);
  const [cachedData, setCachedData] = useState({});
  const isInitialMount = useRef(true);
  const ANSWERS_PER_PAGE = 20


  const closeAnswerPopUp = () => {
    setShowAnswerPopUp(false);
  };

  const handleAddAnswer = (threadId) => {
    setSelectedAnswer(null);
    setThreadId(threadId);
    setAnswerId(null);
    setShowAnswerPopUp(true);
  };
  const handleEditAnswer = (answer, answerId, threadId) => {
    setAnswerId(answerId)
    setSelectedAnswer(answer);
    setThreadId(threadId);
    setShowAnswerPopUp(true);
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setPageIndex(0);
  };

  const handleQuestionClick = (questionId) => {
    window.location.href = window.location.origin + PAGE_HASH_LOCATION.community + `/?id=${questionId}`;
  };

  const handleDeleteAnswer = () => {
    if (answerToDelete) {
      const answerId = answerToDelete;
      const successFunction = () => {
        const updatedThreads = myAnswers.map((item) => {
          const updatedAnswers = item?.answers?.filter((answer) => answer._id !== answerId);
          if(updatedAnswers){
            return {
              ...item,
              answers: updatedAnswers,
              answer_count: updatedAnswers.length,
            };
          }
          return item;
        });
        dispatch({
          type: COMMUNITY_ACTION_TYPES.SET_USER_ANSWERS,
          payload: updatedThreads,
        });
        handleCommunityDeletePopUpClose();
      };
      const failureFunction = (error) => {
        console.error("Failed to delete thread:", error);
        alert("not deleted");
        handleCommunityDeletePopUpClose();
      };
      deleteAnswer(answerId, successFunction, failureFunction);
    }
    else {
      handleCommunityDeletePopUpClose();
    }
  };


  const handleTextChange = (text) => {
    setSearchTerm(text);
  };

  const handleSuccess = (res, index) => {
    dispatch({
      type: COMMUNITY_ACTION_TYPES.SET_USER_ANSWERS,
      payload: res.data || res.search_questions,
    });
    dispatch({
      type: COMMUNITY_ACTION_TYPES.SET_USER_QUESTION_ANSWERS_COUNT,
      payload: res.question_count,
    });
    setCachedData((prevData) => ({
      ...prevData,
      [index]: res.data || res.search_questions,
    }));
  };

  const failureFunction = (error) => {
    console.error('Error fetching questions:', error);
  };

  const userAnsweredQuestions = (index) => {
    if (cachedData[index]) {
      dispatch({
        type: COMMUNITY_ACTION_TYPES.SET_USER_ANSWERS,
        payload: cachedData[index],
      });
      return;
    }
    fetchDetailedAnswers((response) => handleSuccess(response, index), failureFunction, ANSWERS_PER_PAGE, index, searchTerm);
  }


  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      if (user) {
        userAnsweredQuestions(pageIndex);
      }
      return;
    }
    if (user) {
      userAnsweredQuestions(pageIndex);
    }
  }, [user, pageIndex, searchTerm]);

  const handleCopyLink = (threadId) => {
    const link = `${window.location.origin}/#community/?id=${threadId}`;
    navigator.clipboard
        .writeText(link)
        .then(() => {
          setCopiedQuestionId(threadId);
          setCopyStatus((prevState) => ({
            ...prevState,
            [threadId]: "Link Copied",
          }));

          setTimeout(() => {
            setCopiedQuestionId(null);
            setCopyStatus((prevState) => ({
              ...prevState,
              [threadId]: "Copy Link",
            }));
          }, 2000);
        })
        .catch((error) => {
          console.error("Failed to copy text: ", error);
        });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.type === 'click') {
      if (searchTerm) {
        userAnsweredQuestions();
      }
    }
  }



  const handlePageChange = (pageIndex) => {
    setPageIndex(pageIndex.selected);
  }

  return (
      <>
        {
          !isMobileOnly ?
              <>
                <div style={{backgroundColor:'white',marginTop:'-20px'}}>
                  <TopNavBar color={"black"} isCommunity={true}/>
                </div>
                <div className={styles.answerDetailedMain}>
                  <div className={styles.myansContainer}>
                    <img style={{cursor: 'pointer'}}
                         onClick={() => window.location.href = window.location.origin + PAGE_HASH_LOCATION.community}
                         src={backRounded} alt='back' height={35}/>
                    <span className={styles.myans}>My Answers</span>
                  </div>
                  <div className={styles.searchWrapper}>
                    <Provider store={newAdminStore}>
                      <SearchContainer handleTextChange={handleTextChange} handleKeyDown={handleKeyDown} width={940}/>
                    </Provider>
                  </div>
                  {myAnswers?.length === 0 ? (
                      <p className={styles.noAnswers}>No answers found</p>
                  ) : (
                      <div className={styles.questionsContainer}>
                        {myAnswers?.map((question) => (
                            <div onClick={()=> handleQuestionClick(question.question._id)} className={styles.questionItem}>
                              <div className={styles.questionTitle}>
                                <p style={{fontWeight: "bold", fontSize: "16px"}}>
                                  {question?.question?.title}
                                </p>
                                <div
                                    className={styles.copyLinkButton}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      handleCopyLink(question.question._id)
                                    }}
                                >
                                  <img width={15} src={copyLinkIcon} alt="copy"/>
                                  {copyStatus[question.question?._id] || "Copy Link"}
                                </div>
                              </div>
                              <div>
                                <p style={{fontSize: "14px"}}>{question.question?.description}</p>
                                <ActionButtonContainer
                                    buttonText={"+Add Answer"}
                                    fontSize="14px"
                                    buttonWidth="120px"
                                    height="35px"
                                    handleClick={(e) => {
                                      e.stopPropagation()
                                      handleAddAnswer(question?.question._id)
                                    }}
                                />
                                <p style={{fontWeight: "bold"}}>
                                  Your Answers ({question?.answers_count})
                                </p>
                                {
                                  question.answers?.map((answer) => (
                                      <div key={answer._id} style={{padding: "2px 10px"}}>
                                        <div className={styles.answerContainer}>
                                          <div className={styles.answerItem}>
                                            <div style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center'
                                            }}>
                                              <div className={styles.dateContainer}>
                                                <p className={styles.answerDetailedDate}>
                                                  {getDate(answer.answerd_at)}
                                                </p>
                                                <div className={styles.editDeleteButtons}>
                                                  <div className={styles.editButton}
                                                       onClick={(e) => {
                                                         e.stopPropagation()
                                                         handleEditAnswer(answer.community_answer, answer._id, answer.question_id)
                                                       }}
                                                  >
                                                    <div style={{display: "flex"}}>
                                                      <img style={{marginRight: "2px"}} height={12} src={editIcon}
                                                           alt="edit"/>
                                                      <span>Edit</span>
                                                    </div>
                                                  </div>
                                                  <div className={styles.deleteButton}
                                                       onClick={(e) => {
                                                         e.stopPropagation()
                                                         handleCommunityDeletePopUp(answer._id, answer.question_id)
                                                       }}>
                                                    <div style={{display: "flex"}}>
                                                      <img height={12} src={deleteIcon} alt="delete"/>
                                                      <span>Delete</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              {
                                                  answer.isVerified &&
                                                  <div><img src={verifiedMobile} alt='verified' height={30}
                                                            style={{marginTop: '10px'}}/></div>
                                              }
                                            </div>
                                            <div>
                                              {answer.community_answer.split("\n").length > 0 ? (
                                                  answer.community_answer.split("\n").map((line, index) => (
                                                      <p key={index} style={{fontSize: "14px"}}>{line}</p>
                                                  ))
                                              ) : (
                                                  <p style={{fontSize: "14px"}}>{answer.community_answer}</p>

                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                  ))
                                }

                              </div>
                            </div>
                        ))}
                      </div>
                  )}

                  {showAnswerPopUp && (
                      <PopUpContainer>
                        <AddEditAnswerPopUp
                            selectedAnswer={selectedAnswer}
                            threadId={threadId}
                            selectedAnswerId={answerId}
                            onClose={closeAnswerPopUp}
                        />
                      </PopUpContainer>
                  )}

                  {deletePopUp && (
                      <ModalDialog
                          header={"DELETE"}
                          body={<p>Are you sure you want to delete your answer?</p>}
                          buttons={[
                            {
                              text: "CANCEL",
                              action: handleCommunityDeletePopUpClose,
                            },
                            {
                              text: "DELETE",
                              action: handleDeleteAnswer,
                            },
                          ]}
                      />
                  )}
                </div>
                <div style={{marginTop: '-15px'}}>
                  <Paginator handlePageChange={handlePageChange} initialPage={0}
                             totalPageCount={Math.abs(userAnswersCount / ANSWERS_PER_PAGE)}
                             containerClassName={'community-page'}
                  />
                </div>
              </>

              :
              <div className={styles.myAnswerContainer}>
                <div>
                  <h1 className={styles.answersDetailedHead}>My Answers</h1>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                    <div style={{backgroundColor: "white", width: "97%", borderRadius: "20px", marginTop: "12px"}}>
                      <Provider store={newAdminStore}>
                        <SearchContainer
                            handleTextChange={handleSearchChange}
                            width={"300px"}
                            padding={"10px"}
                            height={"30px"}
                        />
                      </Provider>
                    </div>
                    <div>
                      <div style={{marginTop:'15px'}} >
                        <img src={searchBlue} height={40} alt={'search'}/>
                      </div>
                    </div>
                  </div>

                </div>

                <div className={styles.questionList}>
                  {myAnswers?.length > 0 ? (
                      myAnswers?.map((question) => {
                        return (
                            <div
                                key={question.question._id}
                                className={styles.questionItem}
                                onClick={() => handleQuestionClick(question.question._id)}
                            >
                              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <h3 className={styles.questionHead}>{question.question.title}</h3>
                                {copiedQuestionId === question.question._id ? (
                                    <span style={{color: 'gray', fontSize: '16px'}}>Copied!</span>
                                ) : (
                                    <img
                                        src={copyLinkIcon}
                                        alt="Copy link"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleCopyLink(question.question._id);
                                        }}
                                    />
                                )}
                              </div>
                              <p className={styles.questionDesc}>{question.question.description}</p>

                              <ActionButtonContainer
                                  buttonText={"Add Answer"}
                                  fontSize={"16px"}
                                  buttonWidth={"150px"}
                                  handleClick={(e) => {
                                    e.stopPropagation();
                                    handleAddAnswer(question.question._id)
                                  }}
                              />
                              <h4>Your Answers ({question.answers.length})</h4>
                              {
                                question.answers.map((answer) => {
                                  return (
                                      <div key={answer._id} className={styles.answerItem}>
                                        <div className={styles.answerHeader}>
                                          <span>{getDate(answer.answerd_at)}</span>
                                          <div className={styles.answerActions}>
                                            <img
                                                src={editIconMobile}
                                                alt="Edit"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleEditAnswer(answer.community_answer, answer._id, answer.question_id);
                                                }}
                                            />
                                            <img
                                                src={deleteIconMobile}
                                                alt="Delete"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleCommunityDeletePopUp(answer._id, answer.question_id);
                                                }}
                                            />
                                          </div>
                                        </div>
                                        <p style={{color: 'rgba(77, 77, 77, 1)'}}>{answer.community_answer}</p>
                                      </div>
                                  )
                                })
                              }

                            </div>
                        );
                      })
                  ) : (
                      <div className={styles.noAnswersContainer}>
                        <img src={ansIcon} alt="answersIcon"/>
                        <p className={styles.noAnswersText}>You haven't answered any questions yet</p>
                      </div>
                  )}
                </div>

                {showAnswerPopUp && (
                    <PopUpContainer>
                      <AddEditAnswerPopUp
                          selectedAnswer={selectedAnswer}
                          threadId={threadId}
                          selectedAnswerId={answerId}
                          onClose={closeAnswerPopUp}
                      />
                    </PopUpContainer>
                )}

                {deletePopUp && (
                    <ModalDialog
                        header={"DELETE"}
                        body={
                          <p style={{textAlign: "center", margin: "0"}}>
                            Are you sure you want to delete this answer?
                          </p>
                        }
                        buttons={[
                          {
                            text: "CANCEL",
                            action: handleCommunityDeletePopUpClose,
                          },
                          {
                            text: "DELETE",
                            action: handleDeleteAnswer,
                          },
                        ]}
                    />
                )}
                <div>
                  <Paginator handlePageChange={handlePageChange} initialPage={0}
                             totalPageCount={Math.abs(userAnswersCount / ANSWERS_PER_PAGE)}
                             containerClassName={'community-page'}
                  />
                </div>
              </div>
        }
      </>

  );
};

export default CommunityMyAnswersDetailed;